import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, ref, onMounted, onBeforeUnmount } from '@nuxtjs/composition-api';
// @ts-ignore
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import type PhotoSwipeLightboxType from 'photoswipe/dist/types/lightbox/lightbox';
import type { Resource } from '~/types/resource';
import ImageGalleryImage from '~/components/resource/ImageGalleryImage.vue';

import 'photoswipe/dist/photoswipe.css';

interface Props {
  name: string;
  type: string;
  images: Resource['media'];
  fill?: boolean;
  showOnlyMainImage?: boolean;
  eventParams?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageGallery',
  props: {
    name: null,
    type: null,
    images: null,
    fill: { type: Boolean },
    showOnlyMainImage: { type: Boolean },
    eventParams: null
  },
  setup(__props: any) {

const props = __props as {
  name: string;
  type: string;
  images: Resource['media'];
  fill?: boolean;
  showOnlyMainImage?: boolean;
  eventParams?: any;
};


const lightboxOpen = ref(false);
const lightbox = ref<PhotoSwipeLightboxType | null>(null);

const photoSwipeImages = computed(() => {
  return props.images.map(image => {
    if (!image.large?.src && !image.large?.thumbnail) {
      return null;
    }
    // Need this format for the lightbox
    // For all the config options check the Photoswipe docs: https://photoswipe.com/documentation/options.html
    return {
      src: image.large.src || image.large.thumbnail,
      w: image.large.width,
      h: image.large.height,
      alt: `${props.name ?? `Gallery image ${image.large.id}`}`,
    };
  });
});

onMounted(() => {
  if (process.browser) {
    loadPhotoSwipeLightBox();
  }
});

onBeforeUnmount(() => {
  if (!lightbox.value) {
    return;
  }
  if (Object.keys(lightbox.value).length === 0) {
    return;
  }
  lightbox.value.destroy();
});

const loadPhotoSwipeLightBox = () => {
  const options = {
    dataSource: photoSwipeImages.value,
    tapToClose: false,
    showAnimationDuration: 150,
    hideAnimationDuration: 150,
    pswpModule: () => import('photoswipe'),
  };
  lightbox.value = new PhotoSwipeLightbox(options);
  lightbox.value?.on('close', () => {
    lightboxOpen.value = false;
  });
  lightbox.value?.init();
};

const mainImage = computed(() => {
  if (props.images.length > 0) {
    return props.images[0].large || props.images[0].medium;
  }
  return null;
});

const openGallery = () => {
  if (!lightbox.value) {
    return;
  }
  lightbox.value?.loadAndOpen(0);
  lightboxOpen.value = true;
};

return { __sfc: true,props, lightboxOpen, lightbox, photoSwipeImages, loadPhotoSwipeLightBox, mainImage, openGallery, ImageGalleryImage }
}

})